export const PAYMENT_TYPES = {
  ORDER: 'order',
  ORDER_FEE: 'order_fee',
  WAGE: 'wage',
  ACCOUNT: 'account',
  PACKAGE: 'package',
  TAX: 'tax',
  EMPLOYEE_PAYOUT_CONSOLIDATION: 'employee_payout_consolidation',
};
